import React from 'react';
import { Modal } from 'antd';
import { format } from 'date-fns';
import {
  BUG_FEATURE_STATUS,
  BUG_FEATURE_TYPE,
} from 'components/blocks/BugFeatureReportForm/useBugFeatureForm';
import DisplayUserEmail from './DisplayUserEmaiil';
import colors from 'constants/colors';
import BugFeatureAttachment from './BugFeatureAttachment';

export default function DisplayBugFeature({ bugFeature, onClose }) {
  const isBugReport = bugFeature.type === BUG_FEATURE_TYPE.BUG;
  const isTodo = bugFeature.status === BUG_FEATURE_STATUS.TODO;
  const isClosed = bugFeature.status === BUG_FEATURE_STATUS.CLOSED;
  const subject = isBugReport ? 'Bug Report' : 'Feature Request';

  return (
    <Modal
      footer={null}
      title={`${subject} (${bugFeature.id})`}
      visible={!!bugFeature.id}
      width="75%"
      onCancel={onClose}
    >
      {bugFeature.id && (
        <div className="bug-feature-reports">
          <Item label="Summary" value={bugFeature.summary} />

          <IconItem
            icon={isBugReport ? 'bug_report' : 'stars'}
            iconStyle={{
              color: isBugReport ? colors.ERROR : colors.PRIMARY,
            }}
            label="Type"
          >
            {bugFeature.type}
          </IconItem>

          <IconItem
            icon={
              isTodo
                ? 'schedule'
                : isClosed
                ? 'check_circle'
                : 'hourglass_empty'
            }
            iconStyle={{
              color: isTodo
                ? colors.WARNING
                : isClosed
                ? colors.SUCCESS
                : colors.PRIMARY,
            }}
            label="Status"
          >
            {bugFeature.status}
          </IconItem>

          {isBugReport && <Item label="Priority" value={bugFeature.priority} />}

          <Item label="Description" value={bugFeature.description} />

          <Item label="Reporter">
            <DisplayUserEmail id={bugFeature.createdBy} />
          </Item>

          {!isTodo && (
            <Item label="Selected By">
              <DisplayUserEmail id={bugFeature.selectedBy} />
            </Item>
          )}

          {isClosed && (
            <Item label="Closed By">
              <DisplayUserEmail id={bugFeature.closedBy} />
            </Item>
          )}

          <Item
            label="Date Reported"
            value={format(new Date(bugFeature.createdAt), 'yyyy-MM-dd HH:mm')}
          />

          {!isTodo && (
            <Item
              label="Date Selected"
              value={format(
                new Date(bugFeature.selectedAt),
                'yyyy-MM-dd HH:mm',
              )}
            />
          )}

          {isClosed && (
            <Item
              label="Date Closed"
              value={format(new Date(bugFeature.closedAt), 'yyyy-MM-dd HH:mm')}
            />
          )}

          {!!bugFeature.attachments?.length &&
            bugFeature.attachments.map((file, i) => (
              <ul key={i} style={{ marginTop: 3 }}>
                <BugFeatureAttachment attachment={file} />
              </ul>
            ))}
        </div>
      )}
    </Modal>
  );
}

const Item = ({ label, value, children }) => (
  <div className="bug-feature-item">
    <label className="label" htmlFor={label}>
      {label}:
    </label>
    <span className="value" id={label}>
      {value} {children}
    </span>
  </div>
);

const IconItem = ({ label, value, children, icon, iconStyle }) => (
  <Item label={label}>
    <div style={{ display: 'inline-block' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span
          className="material-icons-round"
          style={{
            fontSize: 17,
            paddingRight: 5,
            ...iconStyle,
          }}
        >
          {icon}
        </span>
        {value} {children}
      </div>
    </div>
  </Item>
);
